import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    query,
    setDoc,
    where,
    orderBy,
    limit, deleteDoc
} from "firebase/firestore";
import {fireStoreDB} from "../../firebase/client-app";
import {Promise} from "bluebird";
import _ from "lodash";
import {DATA_LIMIT} from "../constants/facebook-constant";

export {
    addFacebookAdCreatives,
    saveSingleAdCreative,
    addSingleFacebookAdCreative,
    updateSingleFacebookAdCreative,
    deleteSingleFacebookAdCreative,
    getSingleFacebookAdCreative,
    searchFacebookAdCreatives,
    searchFacebookAdCreativesWithSearchCriteria,
    prepareFacebookAdCreativesList
}

const collectionName = 'facebook-ad-creatives';
const collectionReference = collection(fireStoreDB, collectionName);

const saveSingleAdCreative = (adCreative) => {
    const documentReference = doc(fireStoreDB, collectionName, adCreative.id);

    adCreative.updatedAt = new Date();
    if (!adCreative.createdAt) {
        adCreative.createdAt = adCreative.updatedAt;
    }

    return setDoc(documentReference, adCreative, {merge: true});
}

const addFacebookAdCreatives = (facebookAdCreatives) => {
    return Promise.map(facebookAdCreatives, async facebookAdCreative => {
        await addSingleFacebookAdCreative(facebookAdCreative);
    });
}

const addSingleFacebookAdCreative = (facebookAdCreative) => {
    facebookAdCreative.createdAt = new Date();
    facebookAdCreative.updatedAt = facebookAdCreative.createdAt;
    return addDoc(collectionReference, facebookAdCreative);
}

const updateSingleFacebookAdCreative = (facebookAdCreative) => {
    const documentReference = doc(fireStoreDB, collectionName, facebookAdCreative.id);
    facebookAdCreative.updatedAt = new Date();
    return setDoc(documentReference, facebookAdCreative);
}

const deleteSingleFacebookAdCreative = (facebookAdCreative) => {
    const documentReference = doc(fireStoreDB, collectionName, facebookAdCreative.id);
    return deleteDoc(documentReference);
}

const getSingleFacebookAdCreative = async (facebookAdCreativeId) => {
    const documentReference = doc(fireStoreDB, collectionName, facebookAdCreativeId);
    const facebookAdCreativeDoc = await getDoc(documentReference);
    return prepareSingleFacebookAdCreative(facebookAdCreativeDoc);
}

const searchFacebookAdCreatives = async (searchText) => {
    let searchQuery = query(collectionReference);

    if (searchText) {
        searchQuery = query(collectionReference, where("textList", "array-contains", searchText));
    }

    searchQuery = query(searchQuery,
        orderBy('updatedAt', 'desc'));

    searchQuery = query(searchQuery, limit(DATA_LIMIT));

    const facebookAdCreativeResult = await getDocs(searchQuery);
    return prepareFacebookAdCreativesList(facebookAdCreativeResult);
}

const searchFacebookAdCreativesWithSearchCriteria = async (searchCriteriaList) => {
    let searchQuery = query(collectionReference);

    // console.log('searchFacebookAdCreativesWithSearchCriteria', {searchCriteriaList});

    _.forEach(searchCriteriaList, searchCriteria => {
        searchQuery = query(searchQuery,
            where(searchCriteria.field, searchCriteria.condition, searchCriteria.value));
    });

    if (searchCriteriaList.length === 0) {
        searchQuery = query(searchQuery, orderBy('updatedAt', 'desc'));
    }

    searchQuery = query(searchQuery, limit(DATA_LIMIT));

    const facebookAdCreativeResult = await getDocs(searchQuery);
    return prepareFacebookAdCreativesList(facebookAdCreativeResult);
}

const prepareFacebookAdCreativesList = (facebookAdCreativeResult) => {
    const facebookAdCreativesList = [];

    _.forEach(facebookAdCreativeResult.docs, facebookAdCreativeDoc => {
        facebookAdCreativesList.push(prepareSingleFacebookAdCreative(facebookAdCreativeDoc));
    });

    return facebookAdCreativesList;
}


const prepareSingleFacebookAdCreative = (facebookAdCreativeDoc) => {
    const facebookAdCreative = facebookAdCreativeDoc.data();
    facebookAdCreative.id = facebookAdCreativeDoc.id;
    return facebookAdCreative;
}
